module.exports = __webpack_public_path__ + "img/year-settings.b4fc5533.svg";